export const isValidDeviceSn = (value: string) => {
  const regex = /^\d{2}-\d{3}-\d{6}$/
  return regex.test(value?.trim())
}
